import {
    setStorage,
    getStorage,
    createUUid,
    isObject,
    getUrlParam,
    getCookie, removeStorage
} from './tool';

export function setToken(token) {
    let userInfo = token;
    if (isObject(token)) {
        userInfo = JSON.stringify(token);
    }
    setStorage('accessToken', userInfo);
}

export function getToken() {
    let userInfo = getStorage('accessToken') || '{}';
    userInfo = JSON.parse(userInfo);
    return userInfo.token || userInfo.accessToken;
}

export function getMtlToken() {
    const USER_INFO_KEY = 'ncc_userinfo';
    let appCode = getStorage('MTLNccAppCode');
    let userInfo = getStorage("".concat(USER_INFO_KEY, "_").concat(appCode)) || '{}';
    userInfo = JSON.parse(userInfo);
    return userInfo.token;
}

export function getMtlDeviceId() {
    return getStorage('MtlNccDevceid');
}

export function clearToken() {
    removeStorage('accessToken')
}

export function getRandomDeviceId() {
    return createUUid(8) + "-"
        + createUUid(4) + "-"
        + createUUid(4) + "-"
        + createUUid(12)
}

export const getBcCode = () => {
    let busiCenterCode = getUrlParam('bccode');
    if (!busiCenterCode) {
        busiCenterCode = getCookie('busiCenterCode');
    }
    return busiCenterCode;
}

export const setPsndoc = pk_psndoc => {
    setStorage('pk_psndoc', pk_psndoc);
}

export const getPsndoc = () => {
    return getStorage('pk_psndoc');
}

export const clearPsndoc = () => {
    removeStorage('pk_psndoc')
}

export const setThirdPartyToken = token => {
    let userInfo = JSON.stringify(token);
    setStorage('thirdPartyToken', userInfo);
}

export const getThirdPartyToken = () => {
    let userInfo = getStorage('thirdPartyToken') || '{}';
    userInfo = JSON.parse(userInfo);
    return userInfo;
}

export const clearThirdPartyToken = () => {
    removeStorage('thirdPartyToken')
}

export const setThirdPartyUserInfo = (param = {}) => {
    let userInfo = getStorage('third_party_user_info') || '{}';
    userInfo = JSON.parse(userInfo);
    userInfo = Object.assign(userInfo, param);
    setStorage('third_party_user_info', JSON.stringify(userInfo))
}

export const getThirdPartyUserInfo = () => {
    let userInfo = getStorage('third_party_user_info') || '{}';
    userInfo = JSON.parse(userInfo);
    return userInfo;
}

export const clearThirdPartyUserInfo = () => {
    removeStorage('third_party_user_info')
}